import { useStore } from "vuex";
import { createToastInterface } from "vue-toastification";
const toast = createToastInterface();



import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
} from "vue-router";

const isServer = typeof window === "undefined";
const history = isServer ? createMemoryHistory() : createWebHistory();

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: () => import("@/login/login/LandingPage.vue"),
  },
    {
    path: "/contactUs",
    name: "AboutUs",
    component: () => import("@/login/Landing Page Footer/contact_us.vue"),
    meta: { requiresAuth: false },
      // meta: { topbar_sidebar_hide: false },
  },
  {
    path: "/assign-coupon",
    component: () => import("@/assignCoupon.vue"),
  },
  {
    path: "/storage",
    name: "storage",
    component: () => import("@/storage-subscription/purchaseStorage.vue"),
  },
  {
    path: "/assign-default-storage",
    name: "assign-default-storage",
    component: () => import("@/storage-subscription/defaultStorage.vue"),
  },
  {
    path: "/customer",
    name: "CustomerProfile",
    component: () => import("@/profiles/customer-profile/CustomerProfile.vue"),
    meta: { permission: "own_customer_profile:access" },
    // meta: {
    //   title: "Patient Profile - Example App",
    //   requiresPatient: true, // Add a meta field to specify that the route requires admin privileges
    // },
  },
  {
    path: "/doctor",
    name: "DoctorProfile",
    component: () => import("@/profiles/doctor-profile/DoctorProfile.vue"),
    // meta: { permission: "own_doctor_profile:access" },
    // meta: {
    //   title: "Doctor Profile - Example App",
    //   requiresDoctor: true, // Add a meta field to specify that the route requires admin privileges
    // },
  },
  {
    path: "/doctor-dashboard",
    name: "DoctorDashboard",
    component: () => import("@/dashboards/DoctorDashboard.vue"),
    meta: { permission: "own_doctor_profile:access" },
  },
  {
    path: "/doctor-profile-completion",
    name: "DoctorProfileCompletion",
    component: () =>
      import(
        "@/profiles/doctor-profile/doctor-profile-completion/DoctorProfileCompletion.vue"
      ),
    meta: { permission: "own_doctor_profile:access", top_side_hide: false },
  },
  {
    path: "/homeEcommerce",
    // component: () => import("@/E_Commerce/components/Home.vue"),
    props: true,
  },
  {
    path: "/manage-permissions",
    name: "manage-permission",
    component: () => import("@/permissions/RoleTable.vue"),
    meta: { permission: "super_admin:access" },
  },
  {
    path: "/company_module_permissions",
    name: "company_module_permissions",
    component: () => import("@/permissions/CompanyModule_permission.vue"),
    meta: {
      permission: "super_admin:access",
    },
  },
       {
    path: "/company_module_permissions_list",
    name: "company_module_permissions_list",
    component: () => import("@/permissions/Company_module_permission_list.vue"),
    meta: {
      permission: "super_admin:access",
    },
  },

  {
    path: "/update-permissions",
    name: "update-permissions",
    component: () => import("@/permissions/updatePermissions.vue"),
    meta: {
      permission: "super_admin:access",
    },
  },
  {
    path: "/registration-payment",
    name: "RegistrationPayment",
    component: () => import("@/invite-member/RegistrationPayment.vue"),
    meta: { top_side_hide: false },
  },
  {
    path: "/registration-successful",
    name: "RegistrationThankyou",
    component: () => import("@/invite-member/RegistrationThankyou.vue"),
    meta: { top_side_hide: false },
  },
  {
    path: "/registration-payment-successful",
    name: "RegistrationPaymentThankyou",
    component: () => import("@/invite-member/RegistrationPaymentThankyou.vue"),
    meta: { top_side_hide: false },
  },
  {
    path: "/send-invitation",
    name: "InvitationForm",
    component: () => import("@/invite-member/InvitationForm-old.vue"),
  },

  // Health Records
  {
    path: "/add-health-record",
    name: "AddHealthRecord",
    component: () => import("@/health-record/AddHealthRecord.vue"),
  },
  {
    path: "/view-myhealth-record",
    name: "ViewHealthRecord",
    component: () => import("@/health-record/ViewHealthRecord.vue"),
  },
  {
    path: "/patient-health-record/:id",
    name: "ViewPatientHealthRecord",
    component: () => import("@/health-record/ViewPatientHealthRecord.vue"),
  },
  // ******** blog *****************
  {
    path: "/create-blog",
    name: "CreateBlog",
    component: () => import("@/blog/CreateBlog.vue"),
  },
  {
    path: "/blogs",
    name: "AllBlogs",
    component: () => import("@/blog/AllBlogs.vue"),
     meta: {
    requiresAuth: false
  }
  },
  {
    path: "/my-blogs/drafts",
    name: "DraftBlogs",
    component: () => import("@/blog/DraftBlogs.vue"),
  },
  {
    path: "/knowledgebase",
    name: "KnowledgeBase",
    component: () => import("@/blog/KnowledgeBase.vue"),
  },
  {
    path: "/my-blogs",
    name: "MyBlogs",
    component: () => import("@/blog/MyBlogs.vue"),
  },

  {
    path: "/subscribers",
    name: "subscriberlist",
    component: () => import("@/newsletter/subscriber/SubscribersPage.vue"),
  },

  // ********* Big File Sharing ***********

  {
    path: "/large-file-upload",
    name: "LargeFileUpload",
    component: () => import("@/upload-files/LargeFileUpload.vue"),
     meta: {
    requiresAuth: true
  }
  },
  {
    path: "/admin-file-dashboard",
    name: "AdminFileDashboard",
    component: () => import("@/upload-files/AdminFileDashboard.vue"),
  },
  {
    path: "/user-file-dashboard",
    name: "UserFileDashboard",
    component: () => import("@/upload-files/UserFileDashboard.vue"),
  },
  {
    path: "/admin-file-dashboard/:userId/files",
    name: "UserStats",
    component: () => import("@/upload-files/UserStats.vue"),
  },

  // <------------ company ------------>

  {
    path: "/sub_department_communication",
    name: "sub_department_communication",
    component: () => import("@/company/sub_department_communication.vue"),
    meta: {
      permission: "sub_department_communication:access",
    },
  },
  {
    path: "/department_communication",
    name: "department_communication",
    component: () => import("@/company/department_communication.vue"),
    meta: {
      permission: "department_communication:access",
    },
  },
  {
    path: "/building_map",
    name: "building_map",
    component: () => import("@/company/building_map.vue"),
    meta: {
      permission: "building_map:access",
    },
  },
  {
    path: "/building_structure",
    name: "building_structure",
    component: () => import("@/company/building_structure.vue"),
    meta: {
      permission: "building_structure:access",
    },
  },

  {
    path: "/company_directors_details",
    name: "company_directors_details",
    component: () => import("@/company/company_directors_details.vue"),
    meta: {
      permission: "company_directors_details:access",
    },
  },
  {
    path: "/industry",
    name: "company_industry",
    component: () => import("@/company/company_industry.vue"),
    meta: {
      permission: "industry:access",
    },
  },
  {
    path: "/dashboard_company",
    name: "dashboard_company",
    component: () => import("@/company/dashboard_company.vue"),
  },
  {
    path: "/company_creation",
    name: "company_creation",
    component: () => import("@/company/company_creation.vue"),
    meta: {
      permission: "company_creation:access",
    },
  },
  {
    path: "/operation_units",
    name: "operation_units",
    component: () => import("@/company/operation_units.vue"),
    meta: {
      permission: "operation_units:access",
    },
  },
  // <------------Service------------>

  {
    path: "/sub_service_mapping_with_sub_section_sub_department",
    name: "sub_service_mapping_with_sub_section_sub_department",
    component: () =>
      import(
        "../service-management/sub_service_mapping_with_sub_section_sub_department.vue"
      ),
    meta: {
      permission: "sub_service_mapping_with_sub_section_sub_department:access",
    },
  },
  {
    path: "/sub_service_mapping_with_section_department",
    name: "sub_service_mapping_with_section_department",
    component: () =>
      import(
        "../service-management/sub_service_mapping_with_section_department.vue"
      ),
    meta: {
      permission: "sub_service_mapping_with_section_department:access",
    },
  },
  {
    path: "/service_mapping_with_subsection_subdepartment",
    name: "service_mapping_with_subsection_subdepartment",
    component: () =>
      import(
        "../service-management/service_mapping_with_subsection_subdepartment.vue"
      ),
    meta: {
      permission: "service_mapping_with_subsection_subdepartment:access",
    },
  },
  {
    path: "/service_mapping_with_section_department",
    name: "service_mapping_with_section_department",
    component: () =>
      import(
        "../service-management/service_mapping_with_section_department.vue"
      ),
    meta: {
      permission: "service_mapping_with_section_department:access",
    },
  },
  {
    path: "/sub_service_transaction_remark",
    name: "sub_service_transaction_remark",
    component: () =>
      import("../service-management/sub_service_transaction_remark.vue"),
    meta: {
      permission: "sub_service_transaction_remark:access",
    },
  },
  {
    path: "/service_transaction_remark",
    name: "service_transaction_remark",
    component: () =>
      import("../service-management/service_transaction_remark.vue"),
    meta: {
      permission: "service_transaction_remark:access",
    },
  },
  {
    path: "/sub_service_operational_configuration",
    name: "sub_service_operational_configuration",
    component: () =>
      import("../service-management/sub_service_operational_configuration.vue"),
    meta: {
      permission: "sub_service_operational_configuration:access",
    },
  },
  {
    path: "/service_operational_configuration",
    name: "service_operational_configuration",
    component: () =>
      import("../service-management/service_operational_configuration.vue"),
    meta: {
      permission: "service_operational_configuration:access",
    },
  },
  {
    path: "/sub_service_classification_configuration",
    name: "sub_service_classification_configuration",
    component: () =>
      import(
        "../service-management/sub_service_classification_configuration.vue"
      ),
    meta: {
      permission: "sub_service_classification_configuration:access",
    },
  },
  {
    path: "/service_classification_configuration",
    name: "service_classification_configuration",
    component: () =>
      import("../service-management/service_classification_configuration.vue"),
    meta: {
      permission: "service_classification_configuration:access",
    },
  },
  {
    path: "/sub_service_description",
    name: "sub_service_description",
    component: () =>
      import("../service-management/sub_service_description.vue"),
    meta: {
      permission: "sub_service_description:access",
    },
  },
  {
    path: "/service_description",
    name: "service_description",
    component: () => import("../service-management/service_description.vue"),
    meta: {
      permission: "service_description:access",
    },
  },
  {
    path: "/sub_services",
    name: "sub_services",
    component: () => import("../service-management/sub_services.vue"),
    meta: {
      permission: "sub_services:access",
    },
  },
  {
    path: "/services",
    name: "services",
    component: () => import("../service-management/services_create.vue"),
    meta: {
      permission: "services:access",
    },
  },
  {
    path: "/dashboard_Service_management",
    name: "dashboard_Service_management",
    component: () =>
      import("../service-management/dashboard_Service_management.vue"),
    meta: {
      permission: "dashboard_Service_management:access",
    },
  },
  {
    path: "/service_group",
    name: "service_group",
    component: () => import("../service-management/service_group.vue"),
    meta: {
      permission: "service_group:access",
    },
  },

// availability services
 {
    path: "/availability-services",
    name: "AvailabilityForm",
    component: () => import("@/profiles/availabilityServices/AvailabilityForm.vue")
  },

  // <----------- hr --------------->

  {
    path: "/workforce_movement_timings",
    name: "workforce_movement_timings",
    component: () => import("@/hr-module/workforce_movement_timings.vue"),
    meta: {
      permission: "workforce_movement_timings:access",
    },
  },
  {
    path: "/workforce_employee_duty_roaster",
    name: "workforce_employee_duty_roaster",
    component: () => import("@/hr-module/workforce_employee_duty_roaster.vue"),
    meta: {
      permission: "workforce_employee_duty_roaster:access",
    },
  },
  {
    path: "/workforce_mapping_staff",
    name: "workforce_mapping_staff",
    component: () => import("@/hr-module/workforce_mapping_staff.vue"),
    meta: {
      permission: "workforce_mapping_staff:access",
    },
  },
  {
    path: "/workforce_requirments_section",
    name: "workforce_requirments_section",
    component: () => import("@/hr-module/workforce_requirments_section.vue"),
    meta: {
      permission: "workforce_requirments_section:access",
    },
  },
  {
    path: "/workforce_mapping_sections",
    name: "workforce_mapping_sections",
    component: () => import("@/hr-module/workforce_mapping_sections.vue"),
    meta: {
      permission: "workforce_mapping_sections:access",
    },
  },
  {
    path: "/worforce_management",
    name: "worforce_management",
    component: () => import("@/hr-module/worforce_management.vue"),
    meta: {
      permission: "worforce_management:access",
    },
  },
  {
    path: "/user_roles",
    name: "user_roles",
    component: () => import("@/hr-module/user_roles.vue"),
    meta: {
      permission: "user_roles:access",
    },
  },
  {
    path: "/user_sub_group",
    name: "user_sub_group",
    component: () => import("@/hr-module/user_sub_group.vue"),
    meta: {
      permission: "user_sub_group:access",
    },
  },
  {
    path: "/user_group",
    name: "user_group",
    component: () => import("@/hr-module/user_group.vue"),
    meta: {
      permission: "user_group:access",
    },
  },
  {
    path: "/user_category",
    name: "user_category",
    component: () => import("@/hr-module/user_category.vue"),
    meta: {
      permission: "user_category:access",
    },
  },
  {
    path: "/team_financial_share",
    name: "team_financial_share",
    component: () => import("@/hr-module/team_financial_share.vue"),
    meta: {
      permission: "team_financial_share:access",
    },
  },
  {
    path: "/member_team",
    name: "member_team",
    component: () => import("@/hr-module/member_team.vue"),
    meta: {
      permission: "member_team:access",
    },
  },
  {
    path: "/user_team_workforce",
    name: "user_team_workforce",
    component: () => import("@/hr-module/user_team_workforce.vue"),
    meta: {
      permission: "user_team_workforce:access",
    },
  },
  {
    path: "/user_designation",
    name: "user_designation",
    component: () => import("@/hr-module/user_designation.vue"),
    meta: {
      permission: "user_designation:access",
    },
  },
  {
    path: "/user_grade",
    name: "user_grade",
    component: () => import("@/hr-module/user_grade.vue"),
    meta: {
      permission: "user_grade:access",
    },
  },
  {
    path: "/user_roles_responsibility",
    name: "user_roles_responsibility",
    component: () => import("@/hr-module/user_roles_responsibility.vue"),
    meta: {
      permission: "user_roles_responsibility:access",
    },
  },
  {
    path: "/user_financial_details",
    name: "user_financial_details",
    component: () => import("@/hr-module/user_financial_details.vue"),
    meta: {
      permission: "user_financial_details:access",
    },
  },
  {
    path: "/user_employment",
    name: "user_employment",
    component: () => import("@/hr-module/user_employment.vue"),
    meta: {
      permission: "user_employment:access",
    },
  },
  {
    path: "/user_management",
    name: "user_management",
    component: () => import("@/hr-module/user_management.vue"),
    meta: {
      permission: "user_management:access",
    },
  },
  {
    path: "/employment_type",
    name: "employment_type",
    component: () => import("@/hr-module/employment_type.vue"),
    meta: {
      permission: "employment_type:access",
    },
  },
  {
    path: "/section_departments_timings",
    name: "section_departments_timings",
    component: () => import("@/hr-module/section_departments_timings.vue"),
    meta: {
      permission: "section_departments_timings:access",
    },
  },
  {
    path: "/company_working_shifts",
    name: "company_working_shifts",
    component: () => import("@/hr-module/company_working_shifts.vue"),
    meta: {
      permission: "company_working_shifts:access",
    },
  },
  {
    path: "/company_calendar_holiday",
    name: "company_calendar_holiday",
    component: () => import("@/hr-module/company_calendar_holiday.vue"),
    meta: {
      permission: "company_calendar_holiday:access",
    },
  },
  {
    path: "/company_calender",
    name: "company_calender",
    component: () => import("@/hr-module/company_calender.vue"),
    meta: {
      permission: "company_calender:access",
    },
  },
  {
    path: "/liscense_details",
    name: "liscense_details",
    component: () => import("@/hr-module/liscense_details.vue"),
    meta: {
      permission: "liscense_details:access",
    },
  },
  {
    path: "/skill_set_designation",
    name: "skill_set_designation",
    component: () => import("@/hr-module/skill_set_designation.vue"),
    meta: {
      permission: "skill_set_designation:access",
    },
  },
  {
    path: "/skill_set",
    name: "skill_set",
    component: () => import("@/hr-module/skill_set.vue"),
    meta: {
      permission: "skill_set:access",
    },
  },
  {
    path: "/training",
    name: "training",
    component: () => import("@/hr-module/user_training.vue"),
    meta: {
      permission: "training:access",
    },
  },
  {
    path: "/maintaining_scheduling_reason",
    name: "maintaining_scheduling_reason",
    component: () => import("@/hr-module/maintaining_scheduling_reason.vue"),
    meta: {
      permission: "maintaining_scheduling_reason:access",
    },
  },
  {
    path: "/dashboard_hr_module",
    name: "dashboard_hr_module",
    component: () => import("@/hr-module/dashboard_hr_module.vue"),
  },
  {
    path: "/employee_grade",
    name: "employee_grade",
    component: () => import("@/hr-module/employee_grade.vue"),
    meta: {
      permission: "employee_grade:access",
    },
  },

  {
    path: "/create_employee_code",
    name: "create_employee_code",
    component: () => import("../hr-module/create_employee_code.vue"),
    meta: {
      permission: "create_employee_code:access",
    },
  },
  {
    path: "/create_employee_id",
    name: "create_employee_id",
    component: () => import("../hr-module/create_employee_id.vue"),
    meta: {
      permission: "create_employee_id:access",
    },
  },



   {
    path: "/terms_and_conditions",
    name: "ConditionMaster",
    component: () => import("../terms-and-conditions/conditionMaster.vue"),
  },
  //**************Item Management**************** */
   {
    path: "/inventory_management",
    name: "inventoryManagement",
    component: () => import("../item-inventory/inventoryManagement.vue"),
  },
    {
    path: "/stock_transfer",
    name: "stockTransfer",
    component: () => import("../item-inventory/stockTransfer.vue"),
  },
    {
    path: "/item_buying_approval_report",
    name: "ItemBuyingApprovalReport",
    component: () => import("../item-management/item_buying_approval_report.vue"),
  },
      {
    path: "/item_buying_approval_page",
    name: "ItemPricingBuyingApprovalPage",
    component: () => import("../item-management/item_pricing_buying_approval_form.vue"),
  },
  {
    path: "/item_pricing_buying_report",
    name: "item_pricing_buying_report",
    component: () => import("../item-management/item_pricing_buying_report.vue"),
  },
    {
    path: "/item_pricing_buying_edit/:id",
    name: "item_pricing_buying_editPage",
    component: () => import("../item-management/item_pricing_buying_editPage.vue"),
  },
{
    path: "/item_pricing_selling",
    name: "item_pricing_selling",
    component: () => import("../item-management/item_pricing_selling.vue"),
    meta: {
      permission: "item_pricing:access",
    },
  },
  {
    path: "/item_pricing_selling/:id",
    name: "item_pricing_selling_editPage",
    component: () => import("../item-management/item_pricing_selling_editPage.vue"),
  },
  
  {
  path: "/item-selling-approval",
  name: "ItemSellingApprovalReport",
  component: () => import("@/item-management/item_pricing_selling_approval.vue"),
},

{
  path: "/item-selling-approval/:id",
  name: "ItemSellingApprovalEdit",
  component: () => import("@/item-management/item_pricing_selling_approval_editPage"),
},

  {
    path: "/item_pricing_selling_report",
    name: "ItemPricingSellingReport",
    component: () => import("../item-management/item_pricing_selling_report.vue"),
  },
  {
    path: "/item_pricing_buying",
    name: "item_pricing_buying",
    component: () => import("../item-management/item_pricing_buying.vue"),
 
  },
   {
    path: "/item_pricing_buying_international",
    name: "item_pricing_buying_international",
    component: () => import("../item-management/item_pricing_buying_international.vue"),
 
  },
  {
    path: "/item_mapping_with_sub_section_sub_department",
    name: "item_mapping_with_sub_section_sub_department",
    component: () =>
      import(
        "../item-management/item_mapping_with_sub_section_sub_department.vue"
      ),
    meta: {
      permission: "item_mapping_with_sub_section_sub_department:access",
    },
  },
  
  {
    path: "/item_goods_transaction_remarks",
    name: "item_transaction_remarks",
    component: () => import("../item-management/item_transaction_remarks.vue"),
    meta: {
      permission: "item_transaction_remarks:access",
    },
  },
  {
    path: "/item_classification_configuration",
    name: "item_classification_configuration",
    component: () =>
      import("../item-management/item_classification_configuration.vue"),
    meta: {
      permission: "item_classification_configuration:access",
    },
  },

  {
    path: "/material_configuration",
    name: "material_configuration",
    component: () => import("../item-management/material_configuration.vue"),
    meta: {
      permission: "material_configuration:access",
    },
  },

  {
    path: "/item_goods_description_code",
    name: "item_description_code",
    component: () => import("../item-management/item_description_code.vue"),
    meta: {
      permission: "item_description_code:access",
    },
  },

  {
    path: "/item_drug",
    name: "item_drug",
    component: () => import("../item-management/item_drug.vue"),
    meta: {
      permission: "item_drug:access",
    },
  },

  {
    path: "/item_goods_create",
    name: "item",
    component: () => import("../item-management/item_create.vue"),
    meta: {
      permission: "item:access",
    },
  },


  {
    path: "/brand",
    name: "brand",
    component: () => import("../item-management/brand_create.vue"),
    meta: {
      permission: "brand:access",
    },
  },

  {
    path: "/item_goods_sub_category",
    name: "item_sub_category",
    component: () => import("../item-management/item_sub_category.vue"),
    meta: {
      permission: "item_sub_category:access",
    },
  },

  {
    path: "/items_category",
    name: "item_category",
    component: () => import("../item-management/item_category.vue"),
    meta: {
      permission: "item_category:access",
    },
  },
  {
    path: "/item_goods_class",
    name: "item_class",
    component: () => import("../item-management/item_class.vue"),
    meta: {
      permission: "item_class:access",
    },
  },
  {
    path: "/item_goods_sub_group",
    name: "material_sub_group",
    component: () => import("../item-management/material_sub_group.vue"),
    meta: {
      permission: "material_sub_group:access",
    },
  },
  {
    path: "/item_goods_group",
    name: "material_group",
    component: () => import("../item-management/material_group.vue"),
    meta: {
      permission: "material_group:access",
    },
  },
  {
    path: "/item_goods_type",
    name: "material_type",
    component: () => import("../item-management/material_type.vue"),
    meta: {
      permission: "material_type:access",
    },
  },
  {
    path: "/dashboard_item_management",
    name: "dashboard_item_management",
    component: () => import("../item-management/dashboard_item_management.vue"),
    meta: {
      permission: "dashboard_item_management:access",
    },
  },
  {
    path: "/item_goods_category",
    name: "material_category",
    component: () => import("../item-management/material_category.vue"),
    meta: {
      permission: "material_category:access",
    },
  },
    {
    path: "/items_goods_and_distribution",
    name: "inventory_distribution",
    component: () => import("../item-management/ItemsAndGoodsDistribution.vue"),
  },


  /*****************Measurment Unit***************/

  {
    path: "/equivalent_measurement_unit",
    name: "equivalent_measurement_unit",
    component: () =>
      import("../measurement-unit/equivalent_measurement_unit.vue"),
    meta: {
      permission: "equivalent_measurement_unit:access",
    },
  },
  {
    path: "/dashboard_measurement_unit",
    name: "dashboard_measurement_unit",
    component: () =>
      import("../measurement-unit/dashboard_measurement_unit.vue"),
    meta: {
      permission: "dashboard_measurement_unit:access",
    },
  },
  {
    path: "/measurement_unit",
    name: "measurement_unit",
    component: () => import("../measurement-unit/measurement_unit.vue"),
    meta: {
      permission: "measurement_unit:access",
    },
  },
  {
    path: "/measurement_calculator",
    name: "measurement_calculator",
    component: () => import("../measurement_calculator/measurement_tool.vue"),
    meta: {
      permission: "measurement_unit:access",
    },
  },
  /***********************Service Cost Pricing***************** */
  {
    path: "/sub_service_cost_pricing",
    name: "sub_service_cost_pricing",
    component: () => import("../cost-pricing/sub_service_cost_pricing.vue"),
    meta: {
      permission: "sub_service_cost_pricing:access",
    },
  },
  {
    path: "/dashboard_Cost_Pricing",
    name: "dashboard_Cost_Pricing",
    component: () => import("../cost-pricing/dashboard_Cost_Pricing.vue"),
    meta: {
      permission: "dashboard_Cost_Pricing:access",
    },
  },
  {
    path: "/service_cost_pricing",
    name: "service_cost_pricing",
    component: () => import("../cost-pricing/service_cost_pricing.vue"),
    meta: {
      permission: "service_cost_pricing:access",
    },
  },
  // {
  //   path: "/service_cost_pricing_selling",
  //   name: "service_cost_pricing_selling",
  //   component: () => import("../cost-pricing/service_cost_pricing_selling.vue"),
  //   meta: {
  //     permission: "service_cost_pricing_selling:access",
  //   },
  // },
  //     {
  //   path: "/service_cost_pricing_selling_edit",
  //   name: "service_cost_pricing_selling_edit",
  //   component: () => import("../cost-pricing/service_cost_pricing_selling_editPage.vue"),
  //   meta: {
  //     permission: "service_cost_pricing_buying:access",
  //   },
  // },
  
  //   {
  //   path: "/service_cost_pricing_buying",
  //   name: "service_cost_pricing_buying",
  //   component: () => import("../cost-pricing/service_cost_pricing_buying.vue"),
  //   meta: {
  //     permission: "service_cost_pricing_buying:access",
  //   },
  // },
  //     {
  //   path: "/service_cost_pricing_buying_edit",
  //   name: "service_cost_pricing_buying_edit",
  //   component: () => import("../cost-pricing/service_cost_pricing_buying_editPage.vue"),
  //   meta: {
  //     permission: "service_cost_pricing_buying:access",
  //   },
  // },
  
  // {
  //   path: "/service_buying_report",
  //   name: "service_cost_pricing_buying_report",
  //   component: () => import("../cost-pricing/service_cost_pricing_buying_report.vue"),
 
  // },
  //       {
  //   path: "/service_buying_approval_report",
  //   name: "ServiceCostPricingBuyingApprovalList",
  //   component: () => import("../cost-pricing/Service_cost_pricing_buying_approval_report.vue"),
  // },
  //         {
  //   path: "/service_buying_approval_edit/:id",
  //   name: "ServiceCostPricingBuyingApprovalDetail",
  //   component: () => import("../cost-pricing/service_cost_buying_approval_editPage.vue"),
  // },
  //   {
  //   path: "/service_selling_report",
  //   name: "service_cost_pricing_selling_report",
  //   component: () => import("../cost-pricing/service_cost_pricing_selling_report.vue"),
  // },
  //     {
  //   path: "/service_selling_approval_report",
  //   name: "ServiceSellingApprovalReport",
  //   component: () => import("../cost-pricing/service_selling_approval_report.vue"),
  // },

  //       {
  //   path: "/service_selling_approval/:id",
  //   name: "ServiceSellingApprovalDetail",
  //   component: () => import("../cost-pricing/service_selling_approval.vue"),
  // },
     // webniar routes
{
    path: "/VideoCalling",
    name: "video Call",
    component: () => import("../VideoCall/VideoCall.vue"),
  },
  {
    path: "/WebinarNotification",
    name: "WebinarNotification",
    component: () => import("@/VideoCall/WebinarNotification"),
  },
  {
    path: "/streamer",
    name: "Stream Doctor",
    component: () => import("@/VideoCall/Streaming.vue"),
  },
  {
    path: "/selective-invitation",
    name: "selectiveinvitation",
    component: () => import("../VideoCall/SelectiveInvitation.vue"),
  },
  {
    path: "/webinar-list",
    name: "webinarlist",
    component: () => import("../VideoCall/WebinarList.vue"),
  },
    {
  path: "/live-podcasts",
  component: () => import("../VideoCall/PublicWebinars.vue")
},
{
  path: "/create-public-podcast",
  component: () => import("../VideoCall/CreatePublicWebinar.vue")
},
  {
    path: "/webinar/:webinarId",
    name: "Webinar",
    component: () => import("../VideoCall/WebinarRoom.vue"),
  },
  {
    path: "/webinar-ended",
    name: "endWebinar",
    component: () => import("../VideoCall/WebinarEnded.vue"),
  },
    {
    path: "/company-invitation",
    name: "companyinvitation",
    component: () => import("../VideoCall/CompanyInvite.vue"),
  },
  // end

{
    path: "/coinsDashboard",
    name: "Coins Dashboard",
    component: () => import("../portfolio/CoinDashboard.vue"),
  },
 {
    path: "/direct-commission-history/:userId",
    name: "Direct Commission",
    component: () => import("../portfolio/DirectCommission.vue"),
  },
   {
    path: "/referral-commission/:id",
    name: "Referral Commission",
    component: () => import("../portfolio/ReferralCommissioin.vue"),
  },

   {
    path: "/referraltree/:userId",
    name: "Referral Tree",
    component: () => import("../portfolio/ReferralTree.vue"),
  },
     {
    path: "/my-credits",
    name: "My Credits",
    component: () => import("../portfolio/MyCredits.vue"),
  },
 {
    path: "/AdminFamilyDashboard",
    name: "AdminFamilyDashboard",
    component: () => import("../FamilyManagement/AdminFamilyDashboard.vue"),
  },
  {
    path: "/familyPlans",
    name: "FamilyPlans",
    component: () => import("../FamilyManagement/FamilyPlans.vue"),
  },
  {
    path: "/planDetails/:planId",
    name: "PlanDetails",
    params: true,
    component: () => import("../FamilyManagement/components/PlanDetails.vue"),
  },
  {
    path: "/planSummary/:planId",
    name: "PlanSummary",
    params: true,
    component: () => import("../FamilyManagement/PlanSummary.vue"),
  },
  {
    path: "/familyPlan/payment/:planId",
    name: "FamilyPlanPayment",
    params: true,
    component: () => import("../FamilyManagement/MakePayment.vue"),
  },
  {
    path: "/FamilyManagement",
    name: "FamilyManagement",
    component: () => import("../FamilyManagement/FamilyManagement.vue"),
  },
  {
    path: "/all-members-list",
    name: "patientList",
    component: () => import("../FamilyManagement/patientLIst.vue"),
  },
  {
    path: "/find-yourself-in-others-family",
    name: "findYourselfInOthersFamily",
    component: () => import("../FamilyManagement/FindYourselfInOthersFamily.vue"),
  },
    // my income 
  {
    path: '/my-income',
    name: 'IncomePage',
    component: () => import("@/my-income/myIncome.vue")
  },


  // --------------SHow All Doctors-------------------
  {
    path: "/All-Doctors",
    name: "AllDoctors",
    component: () => import("../ShowAllDoctors/AllDoctors.vue"),
  },
  {
    path: "/pet-doctors",
    name: "PetDoctors",
    component: () => import("../ShowAllDoctors/PetDoctors.vue"),
   },
  {
    path: "/Show-Doctors-Profile/:id",
    name: "ShowDoctorProfile",
    component: () => import("../ShowAllDoctors/ShowDoctorProfile.vue"),
  },
   {
    path: "/invoices",
    name: " Inovice Dashboard",
    component: () => import("../InvoiceModels/InvoiceDashboard.vue")
  },
  {
    path: "/transactions",
    name: " Transactions",
    component: () => import("../InvoiceModels/Transactions.vue")
  },

  //Z tracker
  {
    path: "/Z_Tracker",
    name: "Z_Tracker",
    component: ()=> import ( "../AppointmentBlock/Z_Tracker.vue"),
  },
    {
    path: "/follow-following-invitation",
    name: "followfollowinginvitation",
    component: () => import("../VideoCall/FollowFollowerInvite.vue"),
  },
  {
  // New Vue Router 4 syntax for catch-all routes
  path: '/Coming_Soon',
  name: 'ComingSoon',
  component: () => import('../notFoundPage/Comingsoon.vue'),
  meta: {
    title: 'Coming Soon'
  }
},

{
    path: "/prescription-template",
    children: [
      {
        path: "",
        name: "PrescriptionTemplate",
        // component: () => import("../pages/PrescriptionTemplates.vue"),
        component: () => import("../template-builder/allTemplates.vue"),
      },
      {
        path: ":id",
        name: "editTemplate",
        component: () => import("../template-builder/TemplateBuilder.vue"),
      },
      {
        path: "new",
        name: "newTemplate",
        component: () => import("../template-builder/TemplateBuilder.vue"),
      },
    ],
  },
      // job board routes start
  {
    path: "/ViewForRecuiter/:id",
    name: "ViewForRecuiter",
    component: () =>
      import(
        "../jobBoard/ViewForRecuiter.vue"
      ),
  },
  {
    path: "/DiscriptionJob",
    name: "Discript",
    component: () =>
      import(
        "../jobBoard/DiscriptionJob.vue"
      ),
  },
  {
    path: "/savedandAppliedJobs",
    name: "jobboard myitem",
    component: () =>
      import(
        "../jobBoard/jobs_myitem.vue"
      ),
  },
  // {
  //   path: "/homeJobs",
  //   name: "homeJobs",
  //   component: () =>
  //     import(
  //       "../jobBoard/homeJobs.vue"
  //     ),
  // },
  {
    path: "/jobs/:id",
    name: "jobs",
    component: () =>
      import(
        "../jobBoard/jobs_section.vue"
      ),
  },
  {
    path: "/postFreeJobs",
    name: "postFree",
    component: () =>
      import(
        "../jobBoard/postFreeJobs.vue"
      ),
  },
  {
    path: "/reciveApplications",
    name: "reciveApplications",
    component: () =>
      import(
        "../jobBoard/reciveApplications.vue"
      ),
  },
  {
    path: "/review",
    name: "review",
    component: () =>
      import(
        "../jobBoard/review_jobs.vue"
      ),
  },
  {
    path: "/searchJob",
    name: "searchJob",
    component: () =>
      import(
        "../jobBoard/searchJob.vue"
      ),
  },
  {
    path: "/showJobsPage",
    name: "showJobsPage",
    component: () =>
      import(
        "../jobBoard/showJobsPage.vue"
      ),
  },
  {
    path: "/postJobs",
    name: "postJobs",
    component: () =>
      import(
        "../jobBoard/postJobs.vue"
      ),
  },
  {
    path: "/salaryguide",
    name: "salaryguide",
    component: () =>
      import(
        "../jobBoard/salaryguides_jobs.vue"
      ),
  },
  {
    path: "/news",
    name: "news",
    component: () =>
      import(
        "../jobBoard/news_jobs.vue"
      ),
  },
  {
    path: "/demifile",
    name: "demifile",
    component: () =>
      import(
        "../jobBoard/demifile_jobs.vue"
      ),
  },
  {
    path: "/JobDashboard",
    name: "JobDashboard",
    component: () =>
      import(
        "../jobBoard/JobDashboard.vue"
      ),
  },
  {
    path: "/Draft/:id",
    name: "Draft",
    component: () =>
      import(
        "../jobBoard/drafts_section.vue"
      ),
  },
  {
    path: "/chatForApplicant/:roomId",
    name: "chatForApplicant",
    
    component: () =>
      import(
        "../jobBoard/chatForApplicant.vue"
      ),
      
  },
  {
    path: "/InterviewMeeting/:id",
    name: "InterviewMeeting",
    component: () =>
      import(
        "../jobBoard/InterviewMeeting.vue"
      ),
  },

  // job board routes end
 // ********* Big File Sharing ***********


  {
    path: "/admin-file-dashboard",
    name: "AdminFileDashboard",
    component: () => import("@/upload-files/AdminFileDashboard.vue"),
  },
  {
    path: "/user-file-dashboard",
    name: "UserFileDashboard",
    component: () => import("@/upload-files/UserFileDashboard.vue"),
  },
  {
    path: "/admin-file-dashboard/:userId/files",
    name: "UserStats",
    component: () => import("@/upload-files/UserStats.vue"),
  },
     {
  path: '/received-files',
  name: 'ReceivedFiles',
  component: () => import('@/upload-files/ReceivedFiles.vue'),
},
    

 // update profile routes\
  {
    path: "/Doctor-Profile-Details",
    name: "formNew",
    component: () => import("@/resumeTemplate/formNew.vue"),
  },
  // resume routes
  {
    path: "/savedTemplate/:id",
    name: "savedTemplate",
    component: () => import("@/saved resume template/savedTemplate.vue"),
  },

    // questionnaire
  {
    path: "/questionnaire",
    name: "Questionnaire",
    component: () => import("@/questionnaire/QuestionnairePage.vue"),
  },
  {
    path: "/questiongetonebyone",
    name: "Questiongetonebyone",
    component: () => import("@/questionnaire/QuestionGetOneByOne.vue"),
  },
    {
    path: "/testbeforepaymentquestion",
    name: "testbeforepaymentquestion",
    component: () => import("../pop-up/questionnaire/beforePayment.vue"),
  },
   {
    path: "/PreAppointmentPage/:userID",
    name: "PreAppointmentQuestionAnswer",
    component: () => import("@/questionnaire/PreAppointmentQuestions.vue"),
  },
  {
    path: "/showQustion",
    name: "ShowQustion",
    component: () => import("@/questionnaire/showDataPrescription.vue"),
  },
  {
    path: "/questionanswerpatient/:userID",
    name: "QuestionAnswerpatient",
    component: () => import("@/questionnaire/ShowQuestionAnswer.vue"),
  },
   {
    path: "/I_am_following_details",
    name: "IAmFollowing",
    component: () => import("@/profiles/IAmFollowing.vue")
  },
     {
    path: "/my-followers",
    name: "MyFollowers",
    component: () => import("@/profiles/MyFollowers.vue")
  },
   {
    path: "/follow_following_details",
    name: "ShowFollowFollowingDetails",
    component: () => import("@/profiles/ShowFollowFollowingDetails.vue")
  },
// -------------Letter & Drafts-------------------------
  {
    path: "/editorPageTemplate/:templateId?",
    name: "EditorPageTemplate",
    props: true,  // This allows you to pass params to the component
    component: () => import("@/LetterAndDrafts/EditorPage.vue")
  },
  {
    path: "/templateList",
    name: "TemplateList",
    component: () => import("@/LetterAndDrafts/TemplateListPage.vue")
  },
  {
    path: "/templateSelectionPage",
    name: "TemplateSelectionPage",
    component: () => import("@/LetterAndDrafts/TemplateSelectionPage.vue")
  },
  {
    path: "/PreviewDocument/:templateId",
    name: "PreviewDocument",
    component: () => import("@/LetterAndDrafts/previewDocument.vue")
  },
  {
    path: "/shareTemplate",
    name: "shareTemplate",
    component: () => import("@/LetterAndDrafts/shareTemplate.vue")
  },
  {
    path: "/sentTemplates",
    name: "sentTemplates",
    component: () => import("@/LetterAndDrafts/sentTemplatesToUsers.vue")
  },


  {
    path: "/SharedTemplatesWithME",
    name: "SharedTemplatesWithME",
    component: () => import("@/LetterAndDrafts/SharedTemplatesWithME.vue")
  },
{
    path: "/newEditor",
    name: "newEditor",
    component: () => import("@/Editor_November/newEditor.vue")
  },

  /***********************Infrastructure********************** */
  {
    path: "/divisions",
    name: "divisions",
    component: () => import("../infrastructure/divisions-create.vue"),
    meta: {
      permission: "divisions:access",
    },
  },
  {
    path: "/amenities",
    name: "amenities",
    component: () => import("../infrastructure/amenities-create.vue"),
    meta: {
      permission: "amenities:access",
    },
  },
  {
    path: "/amenities_types",
    name: "amenities_types",
    component: () => import("../infrastructure/amenities_types.vue"),
    meta: {
      permission: "amenities_types:access",
    },
  },

  {
    path: "/nursing_unit",
    name: "nursing_unit",
    component: () => import("../infrastructure/nursing_unit.vue"),
    meta: {
      permission: "nursing_unit:access",
    },
  },
  {
    path: "/dashboard_infrastructure",
    name: "dashboard_infrastructure",
    component: () => import("../infrastructure/dashboard_infrastructure.vue"),
    meta: {
      permission: "dashboard_infrastructure:access",
    },
  },
  {
    path: "/level_of_care_infrastructure",
    name: "level_of_care",
    component: () => import("../infrastructure/level_of_care.vue"),
    meta: {
      permission: "level_of_care:access",
    },
  },
  {
    path: "/room",
    name: "room",
    component: () => import("../infrastructure/room-create.vue"),
    meta: {
      permission: "room:access",
    },
  },
  {
    path: "/room_type",
    name: "room-type",
    component: () => import("../infrastructure/room-type.vue"),
    meta: {
      permission: "room_type:access",
    },
  },
  {
    path: "/amenities_category",
    name: "amenities_category",
    component: () => import("../infrastructure/amenities_category.vue"),
    meta: {
      permission: "amenities_category:access",
    },
  },

  /************************************General Module*********************** */
    {
    path: "/tax-create",
    name: "TaxCreate",
    component: () => import("../general/TaxCreate.vue"),
  },
   {
    path: "/currency-create",
    name: "Currency-Create",
    component: () => import("../general/CurrencyCreate.vue"),
  },
  {
    path: "/country",
    name: "country",
    component: () => import("../general/country.vue"),
    meta: {
      permission: "country:access",
    },
  },
  {
    path: "/city",
    name: "city",
    component: () => import("../general/city.vue"),
    meta: {
      permission: "city:access",
    },
  },
  {
    path: "/level_of_care",
    name: "level_of_care",
    component: () => import("../general/level_of_care.vue"),
    meta: {
      permission: "level_of_care:access",
    },
  },
  {
    path: "/patient_visit_type",
    name: "patient_visit_type",
    component: () => import("../general/patient_visit_type.vue"),
    meta: {
      permission: "patient_visit_type:access",
    },
  },
  {
    path: "/age_group",
    name: "age_group",
    component: () => import("../general/age_group.vue"),
    meta: {
      permission: "age_group:access",
    },
  },
  {
    path: "/title_prefix",
    name: "title_prefix",
    component: () => import("../general/title_prefix.vue"),
    meta: {
      permission: "title_prifix:access",
    },
  },
  {
    path: "/state",
    name: "state",
    component: () => import("../general/state.vue"),
    meta: {
      permission: "state:access",
    },
  },
  {
    path: "/religion",
    name: "religion",
    component: () => import("../general/religion.vue"),
    meta: {
      permission: "religion:access",
    },
  },
  {
    path: "/relation",
    name: "relation",
    component: () => import("../general/relation.vue"),
    meta: {
      permission: "relation:access",
    },
  },
  {
    path: "/occupation",
    name: "occupation",
    component: () => import("../general/occupation.vue"),
    meta: {
      permission: "occupation:access",
    },
  },
  {
    path: "/language",
    name: "language",
    component: () => import("../general/language.vue"),
    meta: {
      permission: "language:access",
    },
  },
  {
    path: "/handle_with_care",
    name: "handle_with_care",
    component: () => import("../general/handle_with_care.vue"),
    meta: {
      permission: "handle_with_care:access",
    },
  },
  {
    path: "/education",
    name: "education",
    component: () => import("../general/education.vue"),
    meta: {
      permission: "education:access",
    },
  },
  {
    path: "/dashboard_general",
    name: "dashboard_general",
    component: () => import("../general/dashboard_general.vue"),
    meta: {
      permission: "dashboard_general:access",
    },
  },
  {
    path: "/document_type",
    name: "document_type",
    component: () => import("../general/document_type.vue"),
    meta: {
      permission: "document:access",
    },
  },
  {
    path: "/customer_patient_visit_type",
    name: "customer_patient_visit_type",
    component: () => import("../general/customer_patient_visit_type.vue"),
    meta: {
      permission: "customer_patient_visit_type:access",
    },
  },
/* --------------------- article route start here -------------------- */
  {
    path: "/allArticleCards",
    name: "AllArticleCards",
    component: () => import("../education-article/AllArticleCards.vue")
  },
  {
    path: "/myArticleCards",
    name: "myArticleCards",
    component: () => import("../education-article/MyArticleCards.vue")
  },
  {
    path: "/ArticleById/:id",
    name: "ArticleById",
    component: () => import("../education-article/ArticlebyId.vue")
  },
  {
    path: "/CreateArticle",
    name: "CreateArticle",
    component: () => import("../education-article/CreateArticle.vue")
  },
  {
    path: "/scheduledArticles",
    name: "scheduledArticles",
    component: () => import("../education-article/ScheduledArticles.vue")
  },
  // new Editor routes

{
    path: "/newEditor",
    name: "newEditor",
    component: () => import("../Editor_November/newEditor.vue")
  },

  {
  path: "/receivedArticles",
  name: "ReceivedArticles",
  component: () => import("../education-article/Receivedarticles.vue"),
},

   {
  path: "/editArticle/:id",
  name: "EditArticle",
  component: () => import("../education-article/CreateArticle.vue")
},
  /* ------------------------ article route end here ----------------------- */
  
  {
    path: "/userDashboard",
    name: "userDashboard",
    component: () => import("../Admin_Dashboard/userDashboard.vue"),
  },
  /***************************Machinary************************** */
  {
  path: "/imaging-template-master",
  name: "ImagingTemplateMaster",
  component: () =>
    import("../machinary/ImagingTemplateMaster.vue")
},
  {
  path: "/diagnostic-reports-report",
  name: "DiagnosticReportsReport",
  component: () =>
    import("../machinary/DiagnosticReportsReport.vue")
},
  {
  path:
  "/pending-imaging-report-approval",

  name:
  "PendingImagingReportApproval",

  component:
  () =>
  import(
    "../machinary/PendingImagingReportApproval.vue"
  )
},
{
  path:
  "/PendingLabReportApproval",

  name:
  "PendingLabReportApproval",

  component:
  () =>
  import(
    "../machinary/PendingLabReportApproval.vue"
  )
},
   {
        path: "/signatory-master/create",
        name: 'AuthorizedSignatoryMaster',
         component: () =>
      import(
        "../machinary/Signatory_master.vue"
      ),
       
      },

 {
        path: "/lab-parameter-master/create",
        name: 'LabParameterMasterCreate',
         component: () =>
      import(
        "../machinary/LabTestParameterForm.vue"
      ),
       
      },

   {
    path: "/lab-report-entry",
    name: 'LabReportEntry',
   component: () =>
      import(
        "../machinary/LabReportEntry.vue"
      ),
  },
   {
    path: "/imaging-report-entry",
    name: 'ImagingReportEntry',
   component: () =>
      import(
        "../machinary/ImagingReportEntry.vue"
      ),
  },

    {
    path: '/operator/bookings',
    name: 'OperatorBookings',
   component: () =>
      import(
        "../machinary/OperatorBookings.vue"
      ),
  },
{
    path: '/my-bookings',
    name: 'MyBookings',
    component: () =>
      import(
        "../machinary/MyBookings.vue"
      ),
   
  },
  {
    path: "/machine_user_mapping",
    name: "machine_user_mapping",
    component: () =>
      import(
        "../machinary/machine_user_mapping.vue"
      ),
  },

   {
    path: "/public_booking",
    name: "public_booking",
    component: () =>
      import(
        "../machinary/public_booking.vue"
      ),
  },

  {
    path: "/machine_equipement_classification_configuration",
    name: "machine_equipement_classification_configuration",
    component: () =>
      import(
        "../machinary/machine_equipement_classification_configuration.vue"
      ),
    meta: {
      permission: "machine_equipement_classification_configuration:access",
    },
  },
  {
    path: "/machine_equipement_vehicle_description",
    name: "machine_equipement_vehicle_description",
    component: () =>
      import("../machinary/machine_equipement_vehicle_description.vue"),
    meta: {
      permission: "machine_equipement_vehicle_description:access",
    },
  },
  {
    path: "/machine_equipement_vehicle_transaction_remarks",
    name: "machine_equipement_vehicle_transaction_remarks",
    component: () =>
      import("../machinary/machine_equipement_vehicle_transaction_remarks.vue"),
    meta: {
      permission: "machine_equipement_vehicle_transaction_remarks:access",
    },
  },
  {
    path: "/machine_equipement_vehicle",
    name: "machine_equipement_vehicle",
    component: () => import("../machinary/machine_equipement_vehicle.vue"),
    meta: {
      permission: "machine_equipement_vehicle:access",
    },
  },
  {
    path: "/machine_equipment_vehicle_mapping_with_section_department",
    name: "machine_equipment_vehicle_mapping_with_section_department",
    component: () =>
      import(
        "../machinary/machine_equipment_vehicle_mapping_with_section_department.vue"
      ),
    meta: {
      permission:
        "machine_equipment_vehicle_mapping_with_section_department:access",
    },
  },
  {
    path: "/machine_equipement_vehicle_mapping_with_sub_section_sub_department",
    name: "machine_equipement_vehicle_mapping_with_sub_section_sub_department",
    component: () =>
      import(
        "../machinary/machine_equipement_vehicle_mapping_with_sub_section_sub_department.vue"
      ),
    meta: {
      permission:
        "machine_equipement_vehicle_mapping_with_sub_section_sub_department:access",
    },
  },

  
    { 
      path:"/create_showcase",
      name: "showcase",
      component: () => import("@/NewAlbum/Showcase.vue")
    },
  // This is my personal task 

   {
    path: "/personaltask",
    name: "personaltask",
    component: () => import("../MyPersonalTask/MyPersonalTask.vue"),
  },

  /*********************************Promotion Campaign ****************************/
  {
    path: "/discount_coupons_issue_to_user",
    name: "discount_coupons_issue_to_user",
    component: () =>
      import("../promotion-campaign/discount_coupons_issue_to_user.vue"),
    meta: {
      permission: "discount_coupons_issue_to_user:access",
    },
  },
  {
    path: "/discount_coupon_mapping_with_module",
    name: "discount_coupon_mapping_with_module",
    component: () =>
      import("../promotion-campaign/discount_coupon_mapping_with_module.vue"),
    meta: {
      permission: "discount_coupon_mapping_with_module:access",
    },
  },
  {
    path: "/discount_coupon_mapping_with_item",
    name: "discount_coupon_mapping_with_item",
    component: () =>
      import("../promotion-campaign/discount_coupon_mapping_with_item.vue"),
    meta: {
      permission: "discount_coupon_mapping_with_item:access",
    },
  },
  {
    path: "/discounts_coupon_mapping_with_sub_service",
    name: "discounts_coupon_mapping_with_sub_service",
    component: () =>
      import(
        "../promotion-campaign/discounts_coupon_mapping_with_sub_service.vue"
      ),
    meta: {
      permission: "discounts_coupon_mapping_with_sub_service:access",
    },
  },
  {
    path: "/discounts_coupon_mapping_with_service",
    name: "discounts_coupon_mapping_with_service",
    component: () =>
      import("../promotion-campaign/discounts_coupon_mapping_with_service.vue"),
    meta: {
      permission: "discounts_coupon_mapping_with_service:access",
    },
  },
  {
    path: "/discount_coupon_names",
    name: "discount_coupon_names",
    component: () => import("../promotion-campaign/discount_coupon_names.vue"),
    meta: {
      permission: "discount_coupon_names:access",
    },
  },
  {
    path: "/discount_coupon_season",
    name: "discount_coupon_season",
    component: () => import("../promotion-campaign/discount_coupon_season.vue"),
    meta: {
      permission: "discount_coupon_season:access",
    },
  },

  {
    path: "/marketing_matrix_commission_calculator",
    name: "marketing_matrix_commission_calculator",
    component: () =>
      import(
        "../promotion-campaign/marketing_matrix_commission_calculator.vue"
      ),
    meta: {
      permission: "marketing_matrix_commission_calculator:access",
    },
  },

  /******************Consignment*************** */

  // new page added
{
  path: '/consignment-order-authorization/edit/:id/:company_codes',
  name: 'consignment_order_authorization_edit',
  component: () => import('../consignment/consignment_order_authorization_edit.vue'),
},
  {
    path: "/approve-consignment-order",
    name: "ApproveConsignementOrder",
    component: () => import("../consignment/ApproveConsignementOrder.vue"),
  },
        {
    path: "/consignment_indent_editPage/:id",
    name: "consignment_indent_editPage",
    component: () => import("../consignment/consignment_indent_editPage.vue"),
  },
    {
     path: "/consignment_indent_authorization_editPage/:id/:company_codes",
    name: "consignment_indent_authorization_editPage",
    component: () =>
      import("../consignment/consignment_indent_authorization_editPage.vue"),
  },
      {
    path: "/department_consignment_request_editPage/:id",
    name: "department_consignment_request_editPage",
    component: () =>
      import("../consignment/department_consignment_request_editPage.vue"),
  },
    {
    path: "/ci-report",
    name: "ConsignmentIndentReport",
    component: () =>
      import("../consignment/CiReport.vue"),
  
  },
      {
    path: "/co-with-report",
    name: "ConsignmentOrderWithReport",
    component: () =>
      import("../consignment/consignment_Order_With_Report.vue"),
  },
        {
    path: "/consignment_order_with_indent_edit/:id",
    name: "consignment_order_with_indent_editPage",
    component: () =>
      import("../consignment/consignment_order_with_consignment_indent_editPage.vue"),
  },

  {
    path: "/co-without-report",
    name: "ConsignmentOrderWithoutReport",
    component: () =>
      import("../consignment/consignment_Order_Without_Report.vue"),
  
  },
        {
    path: "/department-consignment-request-report",
    name: "DepartmentConsignmentRequestReport",
    component: () =>
      import("../consignment/Department_Consignment_Request_Report.vue"),
  
  },
  {
    path: "/approve-ci-report",
    name: "ConsignmentIndentAuthorizationReport",
    component: () =>
      import("../consignment/ConsignmentIndentAuthorizationReport.vue"),
  
  },


  {
    path: "/vendor_consignment_order_receiving",
    name: "vendor_consignment_order_receiving",
    component: () =>
      import("../consignment/vendor_consignment_order_receiving.vue"),
    meta: {
      permission: "vendor_consignment_order_receiving:access",
    },
  },
   {
    path: "/vendor_consignment_order_receiving_report",
    name: "vendor_consignment_order_receiving_report",
    component: () =>
      import("../consignment/vcor-report.vue"),
  },
  {
    path: "/consignment_order_authorization",
    name: "consignment_order_authorization",
    component: () =>
      import("../consignment/consignment_order_authorization.vue"),
    meta: {
      permission: "consignment_order_authorization:access",
    },
  },
  {
    path: "/consignment_order_with_consignment_indent",
    name: "consignment_order_with_consignment_indent",
    component: () =>
      import("../consignment/consignment_order_with_consignment_indent.vue"),
    meta: {
      permission: "consignment_order_with_consignment_indent:access",
    },
  },
  { 
    path: "/consignment_order_without_consignment_indent",
    name: "consignment_order_without_consignment_indent",
    component: () =>
      import("../consignment/consignment_order_without_consignment_indent.vue"),
    meta: {
      permission: "consignment_order_without_consignment_indent:access",
    },
  },
    { 
    path: "/consignment_order_without_consignment_indent_edit/:id",
    name: "ConsignmentOrderWithoutEdit",
    component: () =>
      import("../consignment/consignment_order_without_consignment_indent_editPage.vue"),
 
  },
  {
    path: "/consignment_indent_authorization",
    name: "consignment_indent_authorization",
    component: () =>
      import("../consignment/consignment_indent_authorization.vue"),
    meta: {
      permission: "consignment_indent_authorization:access",
    },
  },
  {
    path: "/consignment_indent",
    name: "consignment_indent",
    component: () => import("../consignment/consignment_indent.vue"),
    meta: {
      permission: "consignment_indent:access",
    },
  },
  {
    path: "/department_consignment_request_authorization",
    name: "department_consignment_request_authorization",
    component: () =>
      import("../consignment/department_consignment_request_authorization.vue"),
    meta: {
      permission: "department_consignment_request_authorization:access",
    },
  },
  
  {
    path: "/department_consignment_request",
    name: "department_consignment_request",
    component: () =>
      import("../consignment/department_consignment_request.vue"),
    meta: {
      permission: "department_consignment_request:access",
    },
  },
{
    path: "/item_pricing_buying/report",
    name: "item_pricing_buying_report",
    component: () =>
      import("../item-management/Item-pricing-buying-reportss.vue"),
  },
  /********************************Vendor Module************************** */
  {
    path: "/vendor_mapping",
    name: "vendor_mapping",
    component: () => import("../vendor/vendor_mapping.vue"),
    meta: {
      permission: "vendor_mapping:access",
    },
  },
  {
    path: "/vendor_group",
    name: "vendor_group",
    component: () => import("../vendor/vendor_group.vue"),
    meta: {
      permission: "vendor_group:access",
    },
  },
  {
    path: "/vendor_category",
    name: "vendor_category",
    component: () => import("../vendor/vendor_category.vue"),
    meta: {
      permission: "vendor_category:access",
    },
  },
  {
    path: "/vendor_payment_terms",
    name: "vendor_payment_terms",
    component: () => import("../vendor/vendor_payment_terms.vue"),
    meta: {
      permission: "vendor_payment_terms:access",
    },
  },
  {
    path: "/vendor_service_price_calendar",
    name: "vendor_service_price_calendar",
    component: () => import("../vendor/vendor_service_price_calendar.vue"),
    meta: {
      permission: "vendor_service_price_calendar:access",
    },
  },
  {
    path: "/vendor_item_purchase_information",
    name: "vendor_item_purchase_information",
    component: () => import("../vendor/vendor_item_purchase_information.vue"),
    meta: {
      permission: "vendor_item_purchase_information:access",
    },
  },
  {
    path: "/vendor_service_purchase_information",
    name: "vendor_service_purchase_information",
    component: () =>
      import("../vendor/vendor_service_purchase_information.vue"),
    meta: {
      permission: "vendor_service_purchase_information:access",
    },
  },
  {
    path: "/vendor_service_delivery_conditions",
    name: "vendor_service_delivery_conditions",
    component: () => import("../vendor/vendor_service_delivery_conditions.vue"),
    meta: {
      permission: "vendor_service_delivery_conditions:access",
    },
  },
  {
    path: "/vendor_item_delivery_conditions",
    name: "vendor_item_delivery_conditions",
    component: () => import("../vendor/vendor_item_delivery_conditions.vue"),
    meta: {
      permission: "vendor_item_delivery_conditions:access",
    },
  },
  {
    path: "/vendor_item_price_calendar",
    name: "vendor_item_price_calendar",
    component: () => import("../vendor/vendor_item_price_calendar.vue"),
    meta: {
      permission: "vendor_item_price_calendar:access",
    },
  },
  {
    path: "/create_vendors_sales_personal_details",
    name: "create_vendors_sales_personal_details",
    component: () =>
      import("@/vendor/create_vendors_sales_personal_details.vue"),
    meta: {
      permission: "create_vendor_sales_personal_details:access",
    },
  },
  {
    path: "/vendor_bank",
    name: "vendor_bank",
    component: () => import("../vendor/vendor_bank.vue"),
    meta: {
      permission: "vendor_bank:access",
    },
  },
  {
    path: "/vendor_financial_details",
    name: "vendor_financial_details",
    component: () => import("../vendor/vendor_financial_details.vue"),
    meta: {
      permission: "vendor_financial_details:access",
    },
  },

  /* ***************************Purchase Order***************/
 {
  path: "/vendor_purchase_order_receiving_report",
  name: "vendor_purchase_order_receiving_report",
  component: () =>
    import("../purchase-order/vpor-report.vue"),
  
},
  {
    path: "/vendor_purchase_order_receiving",
    name: "vendor_purchase_order_receiving",
    component: () =>
      import("../purchase-order/vendor_purchase_order_receiving.vue"),
    meta: {
      permission: "vendor_purchase_order_receiving:access",
    },
  },
  {
    path: "/purchase_order_authorization",
    name: "purchase_order_authorization",
    component: () =>
      import("../purchase-order/purchase_order_authorization.vue"),
      meta: {
      permission: "purchase_order_authorization:access",
    },
  },
  {
    path: "/purchase_order_with_purchase_indent",
    name: "purchase_order_with_purchase_indent",
    component: () =>
      import("../purchase-order/purchase_order_with_purchase_indent.vue"),
    meta: {
      permission: "purchase_order_with_purchase_indent:access",
    },
  },
    {
    path: "/approved-reject-pi",
    name: "approved-reject-PI",
    component: () => import("@/purchase-order/ApproveRejectIndent.vue"),
 
  },
      {
    path: "/pi-report",
    name: "pi-report",
    component: () => import("@/purchase-order/PiReport.vue"),
 
  },

   {
    path: "/powpi-report",
    name: "purchase-order-with-purcahse-indent-list",
    component: () => import("@/purchase-order/POWPIreport.vue"),
 
  },
  {
    path: "/powtithoutpi-report",
    name: "purchase-order-without-purcahse-indent-list",
    component: () => import("@/purchase-order/POWITHOUTPIreport.vue"),
 
  },
  // Add this block inside your routes array
{
  path: '/purchase-order-with-purchase-indent/edit/:id',
  name: 'purchase_order_with_purchase_indent_edit',
  component: () => import('../purchase-order/purchase_order_with_purchase_indent_edit.vue'), // ← same component file as create

},
{
  path: '/purchase-order-without-purchase-indent/edit/:id',
  name: 'purchase_order_without_purchase_indent_edit',
  component: () => import('../purchase-order/purchase_order_without_purchase_indent_edit.vue'), // ← same component file as create

},
  {
    path: "/purchase_order_without_purchase_indent",
    name: "purchase_order_without_purchase_indent",
    component: () =>
      import("../purchase-order/purchase_order_without_purchase_indent.vue"),
    meta: {
      permission: "purchase_order_without_purchase_indent:access",
    },
  },
{
  path: "/purchase_indent_authorization",
  name: "purchase_indent_authorization",
  component: () =>
    import("../purchase-order/purchase_indent_authorization.vue"),
  meta: {
    permission: "purchase_indent_authorization:access",
  },
},
{
  path: "/purchase_indent_authorization/edit/:id",
  name: "purchase_indent_authorization_editPage",
  component: () =>
    import("../purchase-order/purchase_indent_authorization_editPage.vue"),
  meta: {
    permission: "purchase_indent_authorization:access",
  },
},
  {
    path: "/purchase_indent_editPage/:id",
    name: "purchase_indent_editPage",
    component: () => import("../purchase-order/purchase_indent_editPage.vue"),
  },
    {
    path: "/department_purchase_request_editPage/:id",
    name: "department_purchase_request_editPage",
    component: () => import("../purchase-order/department_purchase_request_editPage.vue"),
  },
      {
    path: "/purchase_request_auth_editPage/:id",
    name: "purchase_request_auth_editPage",
    component: () => import("../purchase-order/purchase_request_auth_editPage.vue"),
  },
      {
    path: "/approve-department-purchase-request",
    name: "ApproveDepartmentPurchaseReq",
    component: () => import("../purchase-order/ApproveDepartmentPurchaseReq.vue"),
  },
  {
    path: "/approve-purchase-order",
    name: "ApprovePurchaseOrder",
    component: () => import("../purchase-order/ApprovePurchaseOrder.vue"),
  },
  {
    path: '/purchase-order-authorization/edit/:id',
    name: 'purchase_order_authorization_edit',
    component: () => import("../purchase-order/purchase_order_authorization_edit.vue"),  // ← this is the same component you just updated
    props: true,                                 
  },
    {
    path: "/pr-report",
    name: "PrReport",
    component: () => import("../purchase-order/PrReport.vue"),
  },
  {
    path: "/purchase_indent",
    name: "purchase_indent",
    component: () => import("../purchase-order/purchase_indent.vue"),
    meta: {
      permission: "purchase_indent:access",
    },
  },
  {
    path: "/purchase_request_auth",
    name: "purchase_request_auth",
    component: () => import("../purchase-order/purchase_request_auth.vue"),
    meta: {
      permission: "purchase_request_auth:access",
    },
  },
  {
    path: "/department_purchase_request",
    name: "department_purchase_request",
    component: () =>
      import("../purchase-order/department_purchase_request.vue"),
    meta: {
      permission: "department_purchase_request:access",
    },
  },

  /***************************************Store Management*************** */
   {
    path: "/store_mapping_with_user",
    name: "store_mapping_with_user",
    component: () => import("../store-management/store_mapping_with_user.vue"),
    meta:{
      permission: "store_mapping_with_user:access"
    }
  },
    {
    path: "/purchase_order_filter",
    component: () => import("@/store-management/storeManagementFilter.vue"),
      meta:{
      permission: "purchase_order_filter:access"
    }
  },
    {
    path: "/store_mapping_with_item",
    name: "store_mapping_with_item",
    component: () => import("../store-management/store_mapping_with_item.vue"),
    meta:{
      permission: "store_mapping_with_item:access"
    }
  },
  {
    path: "/store_group",
    name: "store_group",
    component: () => import("../store-management/store_group.vue"),
    meta: {
      permission: "store_group:access",
    },
  },

  {
    path: "/sub_store_group",
    name: "sub_store_group",
    component: () => import("../store-management/sub_store_group.vue"),
    meta: {
      permission: "sub_store_group:access",
    },
  },
  {
    path: "/internal_store",
    name: "internal_store",
    component: () => import("../store-management/internal_store.vue"),
    meta: {
      permission: "internal_store:access",
    },
  },
  {
    path: "/external_store",
    name: "external_store",
    component: () => import("../store-management/external_store.vue"),
    meta: {
      permission: "external_store:access",
    },
  },

  {
    path: "/sub_store",
    name: "sub_store",
    component: () => import("../store-management/sub_store.vue"),
    meta: {
      permission: "sub_store:access",
    },
  },

  {
    path: "/storage_location_store",
    name: "storage_location_store",
    component: () => import("../store-management/storage_location_store.vue"),
    meta: {
      permission: "storage_location_store:access",
    },
  },
  {
    path: "/storage_racks",
    name: "storage_racks",
    component: () => import("../store-management/storage_racks.vue"),
    meta: {
      permission: "storage_racks:access",
    },
  },
  {
    path: "/storage_rack_row_dimensions",
    name: "storage_rack_row_dimensions",
    component: () =>
      import("../store-management/storage_rack_row_dimensions.vue"),
    meta: {
      permission: "storage_rack_row_dimensions:access",
    },
  },
  {
    path: "/storage_totes",
    name: "storage_totes",
    component: () => import("../store-management/storage_totes.vue"),
    meta: {
      permission: "storage_totes:access",
    },
  },
  {
    path: "/storage_totes_dividers",
    name: "storage_totes_dividers",
    component: () => import("../store-management/storage_totes_dividers.vue"),
    meta: {
      permission: "storage_totes_dividers:access",
    },
  },
  {
    path: "/storage_bins",
    name: "storage_bins",
    component: () => import("../store-management/storage_bins.vue"),
    meta: {
      permission: "storage_bins:access",
    },
  },
  {
    path: "/storage_bins_dividers",
    name: "store_bins_dividers",
    component: () => import("../store-management/storage_bins_dividers.vue"),
    meta: {
      permission: "storage_bins_dividers:access",
    },
  },

  {
    path: "/store_classification_configuration",
    name: "store_classification_configuration",
    component: () =>
      import("../store-management/store_classification_configuration.vue"),
    meta: {
      permission: "store_classification_configuration:access",
    },
  },

  /********************************CRM********************* */
  {
    path: "/add_customer_data",
    name: "add_customer_data",
    component: () => import("@/crm/add_customer_data.vue"),
    meta: {
      permission: "add_customer_data:access",
    },
  },

  {
    path: "/select_data_for_invitation",
    name: "select_data_for_invitation",
    component: () => import("../crm/select_data_for_invitation.vue"),
    meta: {
      permission: "select_data_for_invitation:access",
    },
  },
  {
    path: "/send_invitation_to_customer",
    name: "send_invitation_to_customer",
    component: () => import("@/crm/send_invitation_to_customer.vue"),
    meta: {
      permission: "send_invitation_to_customer:access",
    },
  },
  {
    path: "/select_preview_data",
    name: "select_preview_data",
    component: () => import("@/crm/select_preview_data.vue"),
    meta: {
      permission: "select_preview_data:access",
    },
  },
  {
    path: "/send_invitation_to_customer",
    name: "send_invitation_to_customer",
    component: () => import("@/crm/send_invitation_to_customer.vue"),
    meta: {
      permission: "send_invitation_to_customer:access",
    },
  },
  {
    path: "/PreviewDocument/:templateId",
    name: "PreviewDocument",
    component: () => import("@/crm/previewDocument.vue"),
  },
  {
    path:"/pre-consultation",
    name:"PreConsultationEditor",
    component: () => import("../template-builder/PreOrPostConsultationEditor.vue")
  },
  {
    path: "/editorPageTemplate/:templateId?",
    name: "EditorPageTemplate",
    component: () => import("@/crm/EditorPage.vue"),
    props: true, // This allows you to pass params to the component
  },
  {
    path: "/templateSelectionPagess",
    name: "TemplateSelectionPagess",
    component: () => import("@/crm/TemplateSelectionPage.vue"),
    meta: {
      permission: "templateSelectionPage:access",
    },
  },

  {
    path: "/create_severity_for_priority",
    name: "create_severity_for_priority",
    component: () => import("../crm/create_severity_for_priority.vue"),
  },

  {
    path: "/create_priority_for_severity",
    name: "create_priority_for_severity",
    component: () => import("../crm/create_priority_for_severity.vue"),
  },

  /******************************* GRN********************** */
  //GRN Routes

  {
    path: "/dashboard_GRN",
    name: "dashboard_GRN",
    component: () => import("../grn/dashboard_GRN.vue"),
  },

  {
    path: "/goods_receipt_note_with_purchase_order",
    name: "goods_receipt_note_with_purchase_order",
    component: () =>
      import("../grn/goods_receipt_note_with_purchase_order.vue"),

    // meta:{
    //   permission: "goods_receipt_note_with_purchase_order:access"
    // }
  },
  {
    path: "/goods_receipt_note_final_list",
    name: "goods_receipt_note_final_list",
    component: () => import("../grn/goods_receipt_note_final_list.vue"),
    // meta:{
    //   permission: "goods_receipt_note_final_list:access"
    // }
  },
  {
    path: "/grn_inspection_details_page/:id",
    name: "grn_inspection_details_page",
    component: () => import("../grn/grn_inspection_details_page.vue"),
  },

  /******************************** Hybrid Management **************************/

  {
    path: "/dashboard_hybrid_management",
    name: "dashboard_hybrid_management",
    component: () =>
      import("../hybrid-management/dashboard_hybrid_management.vue"),
  },
  {
    path: "/hybrid_management",
    name: "hybrid_management",
    component: () => import("../hybrid-management/hybrid_management.vue"),
  },

  // OPD Module
  { path: '/customer_patient_registration', 
  name: 'customer_patient_registration', 
  component: () => import('../opd-module/customer_patient_registration.vue'), 
},
{
    path: "/opd_Calender/:doctorId",
    name: "opd_Calender",
    component: () => import("../opd-module/opd_Calender_Component.vue"),
  },
  {
    path: "/opd_billing",
    name: "opd_billing",
    component: () => import("../opd-module/opd_billing.vue"),
  },
  {
    path: "/opd_doctor/:doctorId/:patientId",
    name: "opd_doctor",
    component: () => import("../opd-module/opd_Doctor_page.vue"),
  },

  {
    path: "/duty-roaster",
    name: "DutyRoaster",
    component: () =>
      import("@/profiles/company-doctor-profile/CompanyDoctorDumy.vue"),
  },
  {
  path: "/attendance-report",
  name: "AttendanceReport",
  component: () => import("@/hr-module/AttendanceReport.vue"),
},
{
  path: "/attendance/employee-detail",
  name: "EmployeeAttendanceDetail",
  component: () => import("@/hr-module/EmployeeAttendanceDetail.vue"),
},
   {
    path: "/employee-attendance",
    name: "AttendancePunch",
    component: () =>
      import("@/hr-module/employee_attendance.vue"),
  },
  {
    path: "/company-doctor",
    name: "CompanyDoctor",
    component: () =>
      import("@/profiles/company-doctor-profile/CompanyDoctorProfile.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () =>
      import("@/profiles/company-doctor-profile/CompanyAdminProfile.vue"),
  },
  {
    path: "/employee",
    name: "companyEmployee",
    component: () =>
      import("@/profiles/company-employee-profile/CompanyEmployeeProfile.vue"),
  },
 
  {
    path: "/Business/:companycode",
    name: "companyBusiness",
    component: () =>
      import("@/profiles/company-business-profile/CompanyBusinessProfile.vue"),
  },

////////////////Advertisement Management/////

  {
    path: "/advertisement_management",
    name: "AdvertisementManagement",
    component: () => import("@/advertisement_management/advertisementManagement.vue"),
    // props: (route) => ({
    //   edit: route.query.edit === 'true',
    //   editAdData: route.params.editAdData
    // })
  },
  {
    path: "/advertisement_management_dashboard",
    name: "AdvertisementManagementDashboard",
    component: () => import("@/advertisement_management/advertisementManagementDashboard.vue")
  },
  {
    path: "/advertisement_management_admin/:id",
    name: "AdvertisementManagementAdmin",
    component: () => import("@/advertisement_management/advertisementManagementAdmin.vue")
  },
  {
    path: "/advertisementInvoice",
    name: "AdvertisementInvoice",
    component: () => import("@/advertisement_management/advertisementInvoice.vue")
  },

  /***************************** Appointment Daybooks***************** */
  {
    path: "/appointment-daybook",
    name: "appointment_daybook",
    component: () => import("../appointment-block/appointmentDaybook.vue"),
  },
   {
  path: "/viewApplicantResume/:id",
  name: "ApplicantResumeView",
  component: () => import("../jobBoard/ApplicantResumeView.vue"),
},

  /*************************** Department Based Invoice Module ******************* */

   {
    path: "/department-based-invoice",
    name:"departmentBasedInvoice",
    component: ()=> import("../deparment-based-invoice/department_based_invoice.vue")
  },


    {
    path: "/department-based-proforma-invoice/:id",
    name:"department-based-proforma-invoice",
    component: ()=> import("../invoice/departmentbased_proformaInvoic.vue")
  },

  /******************* Company Based Invoice Module *************************** */


    {
    path: "/company-based-invoice",
    name:"companyBasedInvoice",
    component: ()=> import("../company-based-invoice/company-based-invoice.vue")
  },


     {
    path: "/company-based-proforma-invoice/:id",
    name:"company-based-proforma-invoice",
    component: ()=> import("../invoice/company_based_proforma_Invoice.vue")
  },

      {
    path:"/order-received-by",
    name: "orderReceivedBy",
      component: () => import("@/e-commerce/components/orderReceivedBy.vue")
  },

  
  /************************ Daybook ******************************/
  {
    path: "/daybook",
    component: () => import("@/daybook-prototype/DaybookLayout.vue"),
    children: [
      // {
      //   path: "pharmacy",
      //   name: "PharmacyDaybook",
      //   component: () => import("@/daybook-prototype/PharmacyDaybook.vue")
      // },
          { 
        path: "pharmacy",
        name: "PharmacyDaybook1",
        component: () => import("@/daybook-prototype/PharmacyDaybook1.vue")
      },
      {
        path: "radiology",
        name: "RadiologyDaybook",
        component: () => import("@/daybook-prototype/RadiologyDaybook.vue")
      }

    ]
  },
    // not found page start here
{
  // New Vue Router 4 syntax for catch-all routes
  path: '/:pathMatch(.*)*',
  name: 'notFound',
  component: () => import('@/notFoundPage/errorPage.vue'),
  meta: {
    title: 'Page Not Found'
  }
},

];

const router = createRouter({
  history,
  routes,
});

router.beforeEach(async (to, from, next) => {
 console.log("Path:", to.path);
  console.log("Meta:", to.meta);
  const store = useStore();
  
  const userPermissions = store.state.user.userPermissions;


 const requiredPermission = to.meta.permission;

const loggedInUser =
  store.state.user.userdetails ||
  JSON.parse(sessionStorage.getItem("user") || "null");

 

  if (to.meta.requiresAuth && !loggedInUser) {
    setTimeout(() => {
    toast.warning("Please login first.");

  }, 100);
  return next("/");
}

if (["Super Admin", "Admin", "director"].includes(loggedInUser?.role)) {
  return next();
}
if (
  requiredPermission &&
  !userPermissions?.includes(requiredPermission)
) {
  return next("/");
}

return next();
});

export default router;
